interface PurchaseSyncedState {
    synced: boolean;
}

const initialState: PurchaseSyncedState = {
    synced: false,
};

const SET_PURCHASE_SYNCED = 'SET_PURCHASE_SYNCED';
const CLEAR_PURCHASE_SYNCED = 'CLEAR_PURCHASE_SYNCED';

interface SetPurchaseSynced {
    type: typeof SET_PURCHASE_SYNCED;
    [key: string]: unknown;
}

interface ClearPurchaseSynced {
    type: typeof CLEAR_PURCHASE_SYNCED;
    [key: string]: unknown;
}

type PurchaseSyncedAction = SetPurchaseSynced | ClearPurchaseSynced;

// eslint-disable-next-line default-param-last
export const purchaseSyncedReducer = (state = initialState, action: PurchaseSyncedAction): PurchaseSyncedState => {
    switch (action.type) {
        case SET_PURCHASE_SYNCED:
            return { synced: true };
        case CLEAR_PURCHASE_SYNCED:
            return { synced: false };
        default:
            return state;
    }
};

export const setPurchaseSynced = (): SetPurchaseSynced => ({ type: SET_PURCHASE_SYNCED });
export const clearPurchaseSynced = (): ClearPurchaseSynced => ({ type: CLEAR_PURCHASE_SYNCED });
